import axios from 'axios';

const ApiCep = {
    SearchCep(cep) {
        return axios.get(`https://viacep.com.br/ws/${cep}/json`);
    }
};

export default ApiCep;